import { AgentGimbalIcon } from './AgentGimbal';
import { McpIcon } from './Mcp';
import { PneumaIcon } from './Pneuma';

const CommendaIcons = {
  AgentGimbal: AgentGimbalIcon,
  Mcp: McpIcon,
  Pneuma: PneumaIcon,
};

export default CommendaIcons;
